import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ArrowLeft from '../../Assets/Arrow left.svg';
import Specification from './Components/Specification.Form';
import PricesAndTaxes from './Components/PricesAndTaxes.Form';
import ProductVariants from './Components/ProductVariants.Form';
import PackagingDetails from './Components/PackagingDetails.Form';
import AddProductImage from './Components/AddProductImage';
import ProductDetails from './Components/ProductDetails.Form';
import ProductOrganisation from './Components/ProductOrganisation.Form';
import Tags from './Components/Tags';
import Inventory from './Components/Inventory.Form';
import { InventoryAddProductFormContext } from '../../Context/InventoryAddProductFormContext';
import Modal from './Components/Modal/Modal';
import { getMediaUrl, loadImage } from '../../lib/utils/utils';
import { createDraftProduct, createProduct } from '../../lib/utils/apiCalls';
import { showToast } from '../../Components/Toaster/Toaster';
import LoadingTransparent from '../../Components/Loading/LoadingTransparent';
import CrossSmall from '../../Assets/CrossSmall.svg';
import { v4 as uuidv4 } from 'uuid';
import imageCompression from 'browser-image-compression';
import { useDispatch } from 'react-redux';
import { fetchInventoryProducts } from '../../Features/inventoryManagementSlice';
import SizeChart from './Components/SizeChart';

function matchInventoryAndAddSku(inventory, inventoryArray) {
    inventory.forEach(inventoryItem => {
        inventoryArray.forEach(variantItem => {
            if (inventoryItem.size === variantItem.VarientSize && 
                inventoryItem.color === variantItem.VarientColor) {
                variantItem.Sku = inventoryItem.Sku;
            }
        });
    });
    
    return inventoryArray;
}

function InventoryAddProducts() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const {
        keywords,
        setKeywords,
        productDetails,
        specifications,
        additionalSpecifications,
        pricesAndTaxes,
        packagingDetails,
        sizeVariants,
        colorVariants,
        inventory,
        inventoryInputs,
        selectedCollections,
        selectedCustomCollections,
        selectedTags,
        productImages,
        formErrors,
        setFormErrors,
        defaultFormErrors,
        loading,
        setLoading,
        productSpecifications,
        inventoryState,
        // setInventoryState,
        selectedChart,
    } = useContext(InventoryAddProductFormContext);

    const [selectedCategory1, setSelectedCategory1] = useState('');
    const [selectedCategory2, setSelectedCategory2] = useState('');

    useEffect(() => {
        const category1 = localStorage.getItem('selectedCategory1');
        const category2 = localStorage.getItem('selectedCategory2');

        setSelectedCategory1(category1);
        setSelectedCategory2(category2);
    }, []);

    const [keywordValue, setKeywordValue] = useState('');

    const handleChange = (e) => {
        setKeywordValue(e.target.value);
    }

    const handleKeyDown = (e) => {
        if(e.key === 'Enter') {
            if(keywords.some(obj => obj.keyword === keywordValue)) {
                showToast('Keyword already present!', 'warning');
            }
            else {
                if(keywordValue) {
                    setKeywords(prev => [...prev, { keyword: keywordValue, id: uuidv4() }]);
                    setKeywordValue('');
                }
            }
        }
    }

    const removeKeyword = (id) => {
        const filteredList = keywords.filter(keyword => keyword.id !== id);
        setKeywords(filteredList);
    }

    const handleDraftClick = async () => {
        const validationErrors = {};

        if(!productDetails.productName.trim()) {
            validationErrors.productName = 'Product name is required';
        }

        if(!pricesAndTaxes.mrp.trim()) {
            validationErrors.mrp = 'Required field';
        }

        if(!String(pricesAndTaxes.sellingPrice).trim()) {
            validationErrors.sellingPrice = 'Required field';
        }

        if(pricesAndTaxes.mrp && pricesAndTaxes.sellingPrice) {
            if(Number(pricesAndTaxes.mrp) < Number(pricesAndTaxes.sellingPrice)) {
                validationErrors.mrp = 'Invalid value';
            }
        }

        if(Object.keys(pricesAndTaxes.taxCode).length === 0) {
            validationErrors.taxCode = 'Required field';
        }

        if(Object.keys(validationErrors).length === 0) {
            setLoading(true);
            setFormErrors(defaultFormErrors);

            let additionals = additionalSpecifications.reduce((acc, spec) => {
                const key = spec.id;
                acc[key] = spec.value;
                return acc;
            }, {});

            let productSpecsList = productSpecifications.reduce((acc, spec) => {
                const key = spec.id;
                acc[key] = spec.value;
                return acc;
            }, {});

            let finalSpecs = {
                ...specifications,
                ...productSpecsList,
                ...additionals,
            }

            let compressedImageList = [];
            const productImagesList = [];

            try {
                const productImagePromises = productImages.map(async image => {
                    if(image.file.size > 1048576) {
                        let compressedBlob = await imageCompression(image.file, {
                            maxSizeMB: 1,
                            maxWidthOrHeight: 1920,
                            useWebWorker: true
                        });

                        let compressedFile = new File([compressedBlob], image.file.name, { type: image.file.type, lastModified: Date.now() });

                        if (compressedFile) {
                            const img = await loadImage(compressedFile);

                            return {
                                id: uuidv4(),
                                url: img.src,
                                file: compressedFile
                            };
                        }
                    }
                    else {
                        return {
                            id: uuidv4(),
                            url: URL.createObjectURL(image.file),
                            file: image.file,
                        }
                    }
                });

                const selectedImages = await Promise.all(productImagePromises);

                compressedImageList = [ ...selectedImages ];
            }
            catch(err) {
                console.log(err);
            }

            for(const image of compressedImageList) {
                const url = await getMediaUrl(image.file);
                productImagesList.push(url);
            }

            let callData = {
                productName: productDetails.productName,
                productDesc: productDetails.productDescription,
                productImgUrls: productImagesList,
                productMRP: pricesAndTaxes.mrp ? pricesAndTaxes.mrp : "0",
                productSellingPrice: pricesAndTaxes.sellingPrice ? pricesAndTaxes.sellingPrice : "0",
                productHSNCode: pricesAndTaxes.hsnCode,
                productTaxCode: Object.keys(pricesAndTaxes.taxCode).length > 0 ? pricesAndTaxes.taxCode.id : '',
                country: pricesAndTaxes.country,
                productSpecs: finalSpecs,
                productStock: inventoryInputs.stock,
                productSKU: inventoryInputs.skuCode,
                productCategory: selectedCategory1,
                productType: selectedCategory2,
                // inventory: updatedInventoryArray,
                collectionIds: selectedCollections.map(collection => collection.id),
                customCollectionId: selectedCustomCollections.map(collection => collection.id),
                keywords: keywords.map(item => item.keyword),
                Tag: selectedTags,
                status: 'Draft',
                height: packagingDetails.height ? packagingDetails.height : "0",
                width: packagingDetails.width ? packagingDetails.width : "0",
                weight: packagingDetails.weight ? packagingDetails.weight : "0",
                isVisible: false,
                // SizeChartId: selectedChart.id,
            };

            try {
                const response = await createDraftProduct(callData);

                if(response?.response?.status === 500) {
                    showToast('Error saving draft.', 'error');
                }
                else if(response?.status === 200) {
                    showToast('Product saved as draft.', 'success');
                    dispatch(fetchInventoryProducts());
                    navigate(`${location.pathname.split('/').slice(0, -1).join('/')}`);
                }
                setLoading(false);
            }
            catch(err) {
                showToast('Error saving draft.', 'error');
                setLoading(false);
            }
        }
        else {
            setFormErrors(validationErrors);
            setLoading(false);
            return;
        }
    }

    const handleSaveClick = async () => {
        const validationErrors = {};

        if(!productDetails.productName.trim()) {
            validationErrors.productName = 'Product name is required';
        }

        if(productImages.length === 0) {
            validationErrors.images = 'Product image is required';
        }

        if(!pricesAndTaxes.mrp.trim()) {
            validationErrors.mrp = 'Required field';
        }

        if(!String(pricesAndTaxes.sellingPrice).trim()) {
            validationErrors.sellingPrice = 'Required field';
        }

        if(pricesAndTaxes.mrp && pricesAndTaxes.sellingPrice) {
            if(Number(pricesAndTaxes.mrp) < Number(pricesAndTaxes.sellingPrice)) {
                validationErrors.mrp = 'Invalid value';
            }
        }

        if(!pricesAndTaxes.hsnCode.trim()) {
            validationErrors.hsnCode = 'Required field';
        }

        if(Object.keys(pricesAndTaxes.taxCode).length === 0) {
            validationErrors.taxCode = 'Required field';
        }

        if(!pricesAndTaxes.country.trim()) {
            validationErrors.country = 'Required field';
        }

        if(selectedCategory1 !== 'Beauty & Personal Care') {
            if(!specifications.color.trim()) {
                validationErrors.color = 'Required field';
            }
        }

        if(!specifications.size.trim()) {
            validationErrors.size = 'Required field';
        }

        if (inventoryInputs.stock === '' || inventoryInputs.stock === 0) {
            validationErrors.stock = 'Required field';
        }

        if (packagingDetails.width === '' || packagingDetails.width == null) {
            validationErrors.width = 'Required field';
        } else if (Number(packagingDetails.width) <= 0) {
            validationErrors.width = 'Must be greater than 0';
        }

        if (packagingDetails.height === '' || packagingDetails.height == null) {
            validationErrors.height = 'Required field';
        } else if (Number(packagingDetails.height) <= 0) {
            validationErrors.height = 'Must be greater than 0';
        }

        if (packagingDetails.weight === '' || packagingDetails.weight == null) {
            validationErrors.weight = 'Required field';
        } else if (Number(packagingDetails.weight) <= 0) {
            validationErrors.weight = 'Must be greater than 0';
        }

        if(keywords.length === 0) {
            validationErrors.keywords = 'Please enter keywords';
        }

        if(Object.keys(validationErrors).length === 0) {
            setLoading(true);
            setFormErrors(defaultFormErrors);

            let additionals = additionalSpecifications?.reduce((acc, spec) => {
                const key = spec.id;
                acc[key] = spec.value;
                return acc;
            }, {});

            let productSpecsList = productSpecifications?.reduce((acc, spec) => {
                const key = spec.id;
                acc[key] = spec.value;
                return acc;
            }, {});

            let finalSpecs = {
                ...specifications,
                ...productSpecsList,
                ...additionals,
            }

            let compressedImageList = [];
            const productImagesList = [];

            try {
                const productImagePromises = productImages.map(async image => {
                    if(image.file.size > 1048576) {
                        let compressedBlob = await imageCompression(image.file, {
                            maxSizeMB: 1,
                            maxWidthOrHeight: 1920,
                            useWebWorker: true
                        });

                        let compressedFile = new File([compressedBlob], image.file.name, { type: image.file.type, lastModified: Date.now() });

                        if (compressedFile) {
                            const img = await loadImage(compressedFile);

                            return {
                                id: uuidv4(),
                                url: img.src,
                                file: compressedFile
                            };
                        }
                    }
                    else {
                        return {
                            id: uuidv4(),
                            url: URL.createObjectURL(image.file),
                            file: image.file,
                        }
                    }
                });

                const selectedImages = await Promise.all(productImagePromises);

                compressedImageList = [ ...selectedImages ];
            }
            catch(err) {
                showToast('Error uploading product images', 'error');
                setLoading(false);
                return;
            }

            for(const image of compressedImageList) {
                const url = await getMediaUrl(image.file);
                productImagesList.push(url);
            }

            let inventoryArray = [];

            if(sizeVariants.length > 0)  {
                let tempArray = [];

                if(colorVariants.length > 0) {
                    const variantsArray = [];

                    const colorVariantsArray = [];

                    for(const colorVariant of colorVariants) {
                        let images = [];

                        for(const image of colorVariant.images) {
                            let url = await getMediaUrl(image.file);
                            images.push(url);
                        }

                        let variantObject = {
                            color: colorVariant.color,
                            variantName: colorVariant.color === specifications.color ? productDetails.productName : colorVariant.variantName,
                            images: colorVariant.primary ? productImagesList : images,
                            id: colorVariant.id
                        };

                        colorVariantsArray.push(variantObject);
                    }

                    sizeVariants.forEach(size => {
                        colorVariantsArray.forEach(color => {
                            let variantId = `${size.id}-${color.id}-form`;
                            const stock = (inventory.find(variant => variant.id === variantId) || {}).stock;

                            let variantObject = {
                                VarientMrp: Number(size.mrp),
                                VarientPrice: Number(size.sellingPrice),
                                VarientSize: size.size,
                                VarientColor: color.color,
                                VarientImgUrl: color.images,
                                VarientName: color.variantName,
                                VarientQuantity: Number(stock),
                            };

                            variantsArray.push(variantObject);
                        });
                    });

                    tempArray = [ ...variantsArray ];
                }

                inventoryArray = tempArray.map(item => {
                    let updatedItem = { ...item };

                    // Check size condition
                    if (item.VarientSize === specifications.size) {
                        updatedItem.VarientMrp = pricesAndTaxes.mrp;
                        updatedItem.VarientPrice = pricesAndTaxes.sellingPrice;
                    }

                    // Check color condition
                    if (item.VarientColor === specifications.color) {
                        updatedItem.VarientImgUrl = productImagesList;
                    }

                    return updatedItem;
                });
            }

            let cleanedInventory = inventoryState.map(({ id, ...rest }) => rest);

            let updatedInventoryArray = matchInventoryAndAddSku(cleanedInventory, inventoryArray);

            let callData = {
                productName: productDetails.productName,
                productDesc: productDetails.productDescription,
                productImgUrls: productImagesList,
                productMRP: pricesAndTaxes.mrp,
                productSellingPrice: pricesAndTaxes.sellingPrice,
                productHSNCode: pricesAndTaxes.hsnCode,
                productTaxCode: pricesAndTaxes.taxCode.id,
                country: pricesAndTaxes.country,
                productSpecs: finalSpecs,
                productStock: inventoryInputs.stock,
                productCategory: selectedCategory1,
                productType: selectedCategory2,
                inventory: updatedInventoryArray,
                collectionIds: selectedCollections.map(collection => collection.id),
                customCollectionId: selectedCustomCollections.map(collection => collection.id),
                keywords: keywords.map(item => item.keyword),
                status: 'Active',
                ...packagingDetails,
                isVisible: true,
            };

            if(selectedTags.length > 0) {
                callData.Tag = selectedTags;
            }

            if(selectedChart && Object.keys(selectedChart).length > 0) {
                callData.SizeChartId = selectedChart.id;
            }

            if(selectedCategory1 === 'Beauty & Personal Care') {
                if(updatedInventoryArray.length === 0) {
                    if(inventoryState.length > 0) {
                        updatedInventoryArray = inventoryState.map(item => {
                            return {
                                VarientMrp: item.mrp || pricesAndTaxes.mrp,
                                VarientPrice: item.sellingPrice || pricesAndTaxes.sellingPrice,
                                VarientSize: item.size,
                                VarientColor: "",
                                VarientImgUrl: productImagesList ?? [],
                                VarientName: productDetails.productName ?? "",
                                VarientQuantity: item.stock ?? 0,
                                Sku: item.Sku ?? ""
                            }
                        });
                    }
                }
            }

            callData.inventory = updatedInventoryArray;

            try {
                const response = await createProduct(callData);

                // eslint-disable-next-line eqeqeq
                if(response.statusCode == '10000') {
                    setLoading(false);
                    showToast(response.message, 'success');
                    dispatch(fetchInventoryProducts());
                    navigate(`${location.pathname.split('/').slice(0, -1).join('/')}`);
                }
            }
            catch(err) {
                setLoading(false);
                showToast('Error creating product!', 'error');
            }
        }
        else {
            setFormErrors(validationErrors);
            setLoading(false);
            return;
        }
    }

    return (
        <div className="w-full overflow-y-scroll pb-16 no-scrollbar">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to={`${location.pathname.split('/').slice(0, -1).join('/')}`} className="img p-[10px] flex items-center justify-center">
                        <img className='w-6 h-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] text-[#121212] font-urbanist-regular font-bold leading-8 text-[24px]">Add a Product</h1>
                </div>
            </div>

            <div className="mt-6 mx-5 flex gap-4">
                <div className="w-[65%] flex flex-col gap-4">
                    <ProductDetails />
                            
                    <AddProductImage 
                        errorText={formErrors.images}
                    />

                    <PricesAndTaxes />

                    <Specification 
                        selectedCategory1={selectedCategory1} 
                        selectedCategory2={selectedCategory2} 
                    />

                    <ProductVariants />

                    <Inventory 
                        selectedCategory1={selectedCategory1} 
                        selectedCategory2={selectedCategory2} 
                    />

                    <PackagingDetails />

                    <div className="flex flex-col gap-6 border border-[#EAEAEA] p-5 rounded-xl">
                        <div className="flex items-center justify-between">
                            <label className='w-fit select-none cursor-pointer font-semibold text-[18px] leading-6 text-[#121212]' htmlFor="keywords">Keywords<span className="text-[#DC2626]">*</span></label>

                            {
                                formErrors.keywords && 
                                <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.keywords}</p>
                            }
                        </div>

                        <div className="h-32 px-3 py-4 bg-[#F5F5F5] border border-[#EAEAEA] rounded-[9px] flex gap-2 flex-wrap focus-within:border-primaryColor">
                            {
                                keywords.map(keyword => {
                                    return (
                                        <div key={keyword.id} className="size-fit border border-[#EAEAEA] bg-[#FFFFFF] rounded px-2 py-1 flex items-center">
                                            <p className='font-normal text-[14px] leading-6 text-[#121212]'>{keyword.keyword}</p>

                                            <button onClick={() => removeKeyword(keyword.id)} className="w-4 h-4 p-[3px] flex items-center justify-center">
                                                <img src={CrossSmall} alt="" />
                                            </button>
                                        </div>
                                    );
                                })
                            }

                            <input 
                                className='py-1 flex-grow h-fit font-normal outline-none text-base bg-transparent text-[#121212] placeholder:text-[#888888]' 
                                placeholder='Type keyword and hit enter' 
                                type="text" 
                                id='keywords' 
                                value={keywordValue} 
                                onChange={handleChange} 
                                onKeyDown={handleKeyDown} 
                            />
                        </div>
                    </div>

                    <div className="flex gap-3 mt-2 ml-auto">
                        <button onClick={handleDraftClick} className='outline-none px-5 py-[10px] bg-[#FFFFFF] rounded font-semibold text-base text-[#808080]'>Save as draft</button>

                        <button onClick={handleSaveClick} className='outline-none px-5 py-[10px] bg-primaryColor hover:bg-primaryAccent rounded font-semibold text-base text-buttonText'>Publish</button>
                    </div>
                </div>

                <div className="w-[35%] flex flex-col gap-4">
                    <ProductOrganisation />

                    <Tags />

                    <SizeChart />
                </div>
            </div>

            <Modal />

            {
                loading && 
                <LoadingTransparent />
            }
        </div>
    );
}

export default InventoryAddProducts;
